import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { I18nPipe } from '../../pipes/i18n.pipe';
import { UtmPreservationService } from '../../../core/services/utm-preservation.service';

@Component({
  selector: 'umkt-inactivity-logged-out-modal',
  standalone: true,
  imports: [CommonModule, I18nPipe],
  template: `
    <div class="modal-overlay" *ngIf="isVisible">
      <div class="modal-container">
        <div class="modal-content">
          <div class="modal-header">
            <i class="bi bi-exclamation-circle"></i>
            <h2>{{ 'components.inactivityModal.title' | i18n }}</h2>
          </div>
          
          <div class="modal-body">
            <p>
              {{ 'components.inactivityModal.message' | i18n }}
            </p>
          </div>
          
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-primary" 
              (click)="onLoginAgain()">
              {{ 'components.inactivityModal.loginButton' | i18n }}
            </button>
            <button 
              type="button" 
              class="btn btn-secondary" 
              (click)="onDismiss()">
              {{ 'components.inactivityModal.closeButton' | i18n }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./logout-inactivity-modal.component.scss']
})
export class InactivityLoggedOutModalComponent {
  @Input() isVisible = false;
  
  @Output() dismiss = new EventEmitter<void>();
  @Output() loginAgain = new EventEmitter<void>();
  private router = inject(Router);
  private utmPreservationService = inject(UtmPreservationService);


  onLoginAgain(): void {
    this.loginAgain.emit();
    const queryParams = this.utmPreservationService.addPreservedUtmToQueryParams({});
    this.router.navigate(['/login'], { queryParams });
  }

  onDismiss(): void {
    this.dismiss.emit();
  }
}
